import { combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux'
import { authReducer } from './authReducers'
import {
  condominiumReducer,
  buildingsReducer,
  cisternsReducer,
  hubsReducer,
  modulesReducer,
  informationsReducer,
  commandsReducer,
  dashboardReducer,
  notificationsReducer
} from './dashboardReducers'
import { uiReducer } from './uiReducers'

export default combineReducers({
  routing: routerReducer,
  auth: authReducer,
  dashboard: dashboardReducer,
  ui: uiReducer,
  condominium: condominiumReducer,
  buildings: buildingsReducer,
  cisterns: cisternsReducer,
  hubs: hubsReducer,
  modules: modulesReducer,
  informations: informationsReducer,
  commands: commandsReducer,
  notifications: notificationsReducer
})



/** WEBPACK FOOTER **
 ** ./src/reducers/index.js
 **/